import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/offer.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import Card from "../../components/general/listCard.jsx";
import Tool from "../../components/general/tool.jsx";
import Footer from "../../components/general/footer.jsx";

const Offer = () => {
  const offers = [
    {
      id: 1,
      title: "Cuisinier en restauration",
      subtitle: "Restauration collective & Caterina",
      location: "Nice (06)",
      titleTime: "Mer. 3 janvier —> Lui. 8 janvier",
      time: "6 jours travaillés",
    },
    {
      id: 2,
      title: "Serveur/Serveuse en restaurant",
      subtitle: "Restauration traditionnelle & Le Bistrot",
      location: "Lyon (69)",
      titleTime: "Mer. 3 janvier —> Lui. 8 janvier",
      time: "6 jours travaillés",
    },
    {
      id: 3,
      title: "Chef de rang",
      subtitle: "Hôtellerie haut de gamme & L'Excellence",
      location: "Paris (75)",
      titleTime: "Mer. 3 janvier —> Lui. 8 janvier",
      time: "6 jours travaillés",
    },
    {
      id: 4,
      title: "Plongeur(se)",
      subtitle: "Restauration rapide & FastFood Express",
      location: "Marseille (13)",
      titleTime: "Mer. 3 janvier —> Lui. 8 janvier",
      time: "6 jours travaillés",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main">
      <NavBar userType="interim" />
      <Card offers={offers} listName="Offres" variant="offres" />
    </div>
  );
};

export default Offer;
